__turbopack_context__.v({
  "carousel": "PrizeCategoryCarousel-module__2N6Z0q__carousel",
  "fullSizeLink": "PrizeCategoryCarousel-module__2N6Z0q__fullSizeLink",
  "header": "PrizeCategoryCarousel-module__2N6Z0q__header",
  "viewAllBadge": "PrizeCategoryCarousel-module__2N6Z0q__viewAllBadge",
  "viewAllCard": "PrizeCategoryCarousel-module__2N6Z0q__viewAllCard",
  "viewAllImage": "PrizeCategoryCarousel-module__2N6Z0q__viewAllImage",
});
